import React, {useEffect, useMemo, useRef, useState} from 'react'
import styles from './EventGroupListingPage.module.css';
import {useParams} from "react-router";
import {AppBar, Checkbox, FormControl, FormControlLabel, Grid, InputLabel, Stack} from "@mui/material";
import axios from "axios";
import SelectInput from '../../components/common/inputs/SelectInput/SelectInput'
import HookForm from "../../components/common/HookForm";
import {useForm} from "react-hook-form";
import {useAutoEvt} from "../../queries/useAutoEvt";
import {Button} from "@material-ui/core";

interface Params {
  eventid: string
}

interface FormData {
    ticketid: number
    sizeid: number
}

const EventGroupListingPage = () => {
    const { eventid } = useParams<Params>()
    const { handleSubmit } = useForm()
    const [includeUnregisteredGuest, setIncludeUnregisteredGuest] = useState(true);
    const [oneGroupPerPage, setOneGroupPerPage] = useState(true);
    const formMethods = useForm<FormData>()
    const { setValue, watch, getValues, setError, clearErrors, setFocus, reset } = formMethods

    console.log(eventid)
    useAutoEvt(eventid)
    const [tagsData, setTagsData] = React.useState({selectedticketid: null, selectedsizeid: null, sizelist: [], ticketlist: [], userdefinedlist: [], status: '', message: ''})

    const getTagsData = async () => {
        var body = {'eventid': eventid}
        const { data } = await axios.post('/evtnametags', body)
        const parsedData = JSON.parse(data.jsonString)
        console.log(parsedData)

        reset({
            ticketid: parsedData.selectedticketid,
            sizeid: parsedData.selectedsizeid
        })
        setTagsData(parsedData)
    }

    useEffect(() => {
        // evtnametags
        getTagsData()
    }, [])

    const sizeList = tagsData && tagsData.sizelist ? tagsData.sizelist : []
    const userDefinedOptions = useMemo(
        () => sizeList.map((size) => {
            return { value: size.sizeid, label: size.sizename }
        }),
        [sizeList]
    )

    const ticketTypeList = tagsData && tagsData.ticketlist ? tagsData.ticketlist : []
    const ticketTypeOptions = useMemo(
        () => ticketTypeList.map((ticketType) => {
            return { value: ticketType.ticketid, label: ticketType.ticketname }
        }),
        [ticketTypeList]
    )
    const onSubmit = async (data: FormData) => {}
    const onSubmitExcel = async (data: FormData) => {
        const values = getValues()
        const body = {
            eventid: Number(eventid), type: 'exportalltoexcel',
            includeunregisteredguests: includeUnregisteredGuest,
            onegroupperpage: oneGroupPerPage,  ...values}
        console.log(body)
        axios.post(`evtnametagsprocess`, body).then(response => {})
    }

    const onSubmitPDF = async (data: FormData) => {
        const values = getValues()
        const body = {
            eventid: Number(eventid), type: 'exportpdf',
            includeunregisteredguests: includeUnregisteredGuest,
            onegroupperpage: oneGroupPerPage,  ...values}
        console.log(body)
        axios.post(`evtnametagsprocess`, body).then(response => {})
    }

    const handleUnregisteredGuests = (event) => {
        setIncludeUnregisteredGuest(event.target.checked);
    }

    const handleOneGroupPerPage = (event) => {
        setOneGroupPerPage(event.target.checked);
    }

    return (
      <div className={styles.root}>
        <h1>Group Listing Report</h1>
          <HookForm
              methods={formMethods}
              onSubmit={onSubmit}
              className={styles.itemsForm}
              formProps={{ id: 'items-form' }}>
              <Grid container spacing={3}>
                  <Grid item xs={6} style={{ display: 'flex', flexDirection: 'column' }}>
                      <SelectInput
                          name={'ticketid'}
                          label={'Ticket Type'}
                          options={ticketTypeOptions}
                          includeNone={false}
                      />
                  </Grid>
                  <Grid item xs={6} style={{ display: 'flex', flexDirection: 'column' }}>
                  </Grid>
                  <Grid item xs={6} style={{ display: 'flex', flexDirection: 'column' }}>
                      <SelectInput
                          name={'userdefinedid'}
                          label={'Included User Defined Fields'}
                          options={userDefinedOptions}
                          includeNone={false}
                      />
                  </Grid>
                  <Grid item xs={6} style={{ display: 'flex', flexDirection: 'column' }}>
                  </Grid>
                  <Grid item xs={12} style={{ display: 'flex', flexDirection: 'column' }}>
                      <FormControlLabel
                          control={
                              <Checkbox
                                  checked={includeUnregisteredGuest}
                                  onChange={handleUnregisteredGuests}
                                  name="includeunregisteredguests"
                              />
                          }
                          label="Include Unregistered Guests"
                      />
                  </Grid>
                  <Grid item xs={12} style={{ marginBottom: '20px', display: 'flex', flexDirection: 'column' }}>
                      <FormControlLabel
                          control={
                              <Checkbox
                                  checked={oneGroupPerPage}
                                  onChange={handleOneGroupPerPage}
                                  name="oneGroupPerPage"
                              />
                          }
                          label="One Group Per Page"
                      />
                  </Grid>
              </Grid>

              <Grid container spacing={0}>
                  <Grid item xs={2.5} style={{ display: 'flex', flexDirection: 'column' }}>
                      <Button onClick={handleSubmit(onSubmitExcel)} name="generateword" type="submit" color="primary" variant="contained" className={styles.button}>
                          Export To Excel
                      </Button>
                  </Grid>
                  <Grid item xs={.5} style={{ marginBottom: '15px', display: 'flex', flexDirection: 'column' }}>
                  </Grid>
                  <Grid item xs={2.5} style={{ display: 'flex', flexDirection: 'column' }}>
                      <Button onClick={handleSubmit(onSubmitPDF)} name="generatepdf" type="submit" color="primary" variant="contained" className={styles.button}>
                          Generate PDF
                      </Button>
                  </Grid>
              </Grid>
          </HookForm>
      </div>
    )
}

export default EventGroupListingPage
